import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession, useConfig, useTransmit } from '../../../hooks';

interface IProps {
  children: React.ReactNode;
}

const AuthRoute: React.FC<IProps> = ({ children }) => {
  const { isLoggedIn } = useSession();
  const { environment } = useConfig();
  const { ticketID } = useTransmit();
  const location = useLocation();

  if (isLoggedIn && !ticketID) {
    return <>{children}</>;
  }

  return (
    <Navigate
      to={{
        pathname:
          environment === 'prod' || environment === 'qa'
            ? '/authenticating'
            : '/login',
        search: location.search,
      }}
      state={{ from: window.location.pathname }}
      replace
    />
  );
};

export default AuthRoute;
